import { getNumOfDaysFromDates } from "../getLastNdays";
import {
  reduceExtractedData as dataReducer,
  dataFormatter,
} from "../lineChartHelper";
import {
  branchBasedFeedbackDataFilter,
  getActiveBranchIds1,
} from "../multipleBranch/getActiveBranchId";

// Difference in calculating staff score for report page and staff page
// is due to fact that in report page data should be of between 2 dates
// but in staff page datat is always from today since n number of days
export function genStaffDataForReport(data, dateArr) {
  // i will filter data branchwise here and then supply to diff functions
  if (data == null || data.length == 0) {
    return null;
  }

  console.log("data in staff data generator is ");
  console.log(data);
  console.log("date arr in staff data generator is ");
  console.log(dateArr);

  // BELOW CHECK IS MUST since on initital render date will be null hence causes error.
  if (dateArr == null) return null;
  let activeBranches = getActiveBranchIds1();

  let superData = [];
  activeBranches.forEach((bId) => {
    let obj = {
      bId: bId,
      data: [],
      tableData: [],
    };

    let d1 = dataExtractor(data, dateArr);
      console.log(d1)
    let d2 = dataReducer(d1, bId);
     console.log(d2);
    let d3 = dataFormatter(d2);
  
   
    console.log(d3);
    //console.log(d3);
    if (d3 == null) return null;
    obj.data.push(d3.data);
    obj.tableData = d3.tableData;
    superData.push(obj);
  });
  //console.log(superData);
  return superData;
}

function branchwiseDataExtract(data) {}

function getAllDatesBetweenTwoDates(dateArr) {
  // OUTPUT format ['2025-03-23', '2025-03-22', '2025-03-21'....]
  // which is proper string which can be converted to date object as well for comparison.
  //dateArr is array of two dates.

  //   let numOfDays = getNumOfDaysFromDates(dateArr);

  //   let d1 = new Date(dateArr[0]);

  //   let dates = [];

  //   for (let i = 0; i < numOfDays; i++) {
  //     let temp = new Date(dateArr[0]);
  //     temp.setDate(d1.getDate() + i);

  //     dates.push(temp.toDateString());
  //   }

  //   return dates;

  // OUTPUT format '2024-11-07', '2024-11-06',
  //days is for how many days we need dates starting from d1
  // need to create a label array with following dates between 2 dates.
  //formate of d1   = dd/mm/yyy will not work in new Date() we need yyyy/mm/dd
  // label = ["2024-11-01","2024-11-01","2024-11-01",...]

  let dates = [];
  let numOfDays = getNumOfDaysFromDates(dateArr);

  let td = new Date(dateArr[0]);
  //console.log(td);
  for (let i = 0; i < numOfDays; i++) {
    let d = new Date(dateArr[1]);

    let decrease = d.getDate() - i;
    d.setDate(decrease);

    // let dateString = d.toISOString().split("T")[0];

    // using toISOString() gives a time thats 330 mins behind our time zone hence using
    let ds = d.toLocaleDateString("en-In");
    //console.log(ds);
    let test = ds.split("/");

    // changing the date format from 8/11 to 08/11 so that strings match from DB dates.
    if (test[0].length == 1) {
      test[0] = `0${test[0]}`;
      ds = test.join("/");
    }

    // changing date foramt if month is single digit then change to 02 from 2 ex 01-02-2025
    if (test[1].length == 1) {
      test[1] = `0${test[1]}`;
      ds = test.join("/");
    }
    let newDate = ds.split("/").reverse().join("-");

    // now we remove year part to get just dd/mm
    // let tArr = dateString.split("/");
    // tArr.splice(2);
    // let finalDateString = tArr.join("/");
    dates.push(newDate);
  }

  //console.log(dates);
  return dates;

  //   console.log(Date.parse());
  //   let date1 = new Date(d1);
  //   date1.setDate(date1.getDate() + 15);
  //   console.log();
  //   console.log(new Date(Date.parse(date1.toDateString())));
}

function dataExtractor(data1, dateArr) {
  //console.log(data1);
  let data = [];
  data1.forEach((item) => {
    let tdate = item.createdAt;
    //console.log(tdate);
    if (item.staff?.rating != undefined)
      data.push({ staff: item.staff, date: item.createdAt.split("T")[0] });
  });

  let datesArr = getAllDatesBetweenTwoDates(dateArr);

  const output = {
    dates: datesArr,
    data: data,
  };
  //console.log(output);

  return output;
}
